import { Component } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

export interface Item { name: string; }

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  printUser(event: any) {
    console.log(event);
  }

  printError(event: any) {
   console.error(event);
  }
  private itemDoc: AngularFirestoreDocument<Item>;
  items: Observable<any[]>;
  constructor(db: AngularFirestore)
  {
    this.items = db.collection('items').valueChanges();
    }
    title = 'hias';
}
